// TODO: Change name to title etc. for company flow
const KYBStatusFailed = {
  NameFailed: 'name',
  TitleFailed: 'title',
  AddressFailed: 'address',
  GeneralFailed: 'general',
  IDFailed: 'employer_id_number'
};

const addressRequirements = [
  'We need to see all four corners of the document, and the business name you are verifying must be clearly visible.',
  'Original PDFs are best.'
];

const titleRequirements = [
  'We need to see all four corners of the document, and the business name you are verifying must be clearly visible.',
  'Original PDFs are best.'
];

const iDRequirements = [
  'We need to see all four corners of the document, and the business name you are verifying must be clearly visible.',
  'Original PDFs are best.'
];

const generalRequirements = [
  'Clear photos only; we cannot accept screenshots or scans.',
  'All documents must be current. IDs cannot be expired.',
  'We need to see all four corners of the document, and the information we need to verify must be clearly readable.',
  'Send us images of both the front and the back of the document.',
  'If the document has a signature requirement, then it must be hand-signed. We cannot accept electronic signatures (with the exception of leases, where electronic signatures are acceptable).',
  'Government-issued documents (such as a state-issued ID or passports) must be in color. We can accept black-and-white photos or PDFs of other documents, such as utility bills.'
];

const generalGuide = [
  'Obtain a clear selfie from your individual user. The Selfie should include a clear photo of their face and the document of their choice. In other words, the user should hold up their document near their face such that a selfie clearly captures both their face and the document.'
];

const addressDocumentList = [
  'Articles of Incorporation or Certificate of Formation (for LLCs.)',
  'IRS EIN verification letter',
  'Tax Return',
  'Credit Card Statement (not older than 30 days)',
  'Bank Statement (not older than 30 days)'
];

const einDocumentList = [
  'IRS EIN verification letter',
  'IRS Tax return',
  'IRS Form W-9',
  'IRS Form SS-4'
];

const titleDocumentList = [
  'Articles of Incorporation or Certificate of Formation (for LLCs.)',
  'A state Certificate of Good Standing',
  'IRS EIN verification letter',
  'Business license',
  'Tax return'
];

const generalDocumentList = [
  "State-issued driver's license",
  "Driver's permit",
  'State ID card',
  'Military ID',
  'Passport (both pages)'
];

export const COMPANY_MODAL_DATA = {
  [KYBStatusFailed.AddressFailed]: {
    title: 'Business & ID Verification - Business Address Verification',
    subTitle: 'Business Address Verification or Update',
    instruction:
      "If you change your company address, we'll need to update that address in our databases as well. Likewise, in some cases a potential customer can fail ID verification due to their business address. The following is a list of documents we can accept to verify or update your customer's business address.",
    explainDoc: 'A clear photo of one of the following documents:',
    documentRequirements: addressRequirements,
    documentList: addressDocumentList
  },
  [KYBStatusFailed.NameFailed]: {
    title: 'Business & ID Verification - Business Name Verification',
    subTitle: 'Business Name Verification or Update',
    instruction:
      "If you change your legal business name, we'll need to update the legal business name in our databases as well. Likewise, in some cases a potential customer can fail ID verification due to their business name. The following is a list of documents we can accept to verify or update your customers legal business name.",
    explainDoc: 'A clear photo of one of the following documents:',
    documentRequirements: titleRequirements,
    documentList: titleDocumentList
  },
  [KYBStatusFailed.IDFailed]: {
    title: 'Business & ID Verification - FEIN Verification',
    subTitle: 'Federal EIN Verification or Update',
    instruction:
      "If you form a new legal entity then we'll need to update the entity's Federal EIN in our databases. Likewise, in some cases a potential customer can fail ID verification due to their FEIN. The following is a list of documents we can accept to verify or update your customer's FEIN.",
    explainDoc: 'A clear photo of one of the following documents:',
    documentRequirements: iDRequirements,
    documentList: einDocumentList
  },
  [KYBStatusFailed.GeneralFailed]: {
    title: 'ID Verification - General Identity Verification',
    subTitle: 'General Identity Verification',
    instruction:
      'You have to upload 2 documents. You must send in a photo selfie holding your ID document, as well as a clear and readable photo of your ID document.',
    explainDoc:
      'Request one document from the list below.\nThe front and back of a current photo ID, such as a:',
    warning: "Please note: we're not able to accept temporary IDs",
    documentRequirements: generalRequirements,
    documentsGuide: generalGuide,
    documentList: generalDocumentList
  }
};

export const COMPANY_DOCUMENT_LIST = {
  [KYBStatusFailed.NameFailed]: [
    'doc_articles_of_inc',
    'doc_cert_of_good_standing',
    'doc_ein_verification',
    'doc_business_license',
    'doc_tax_return'
  ],
  [KYBStatusFailed.AddressFailed]: [
    'doc_articles_of_inc',
    'doc_ein_verification',
    'doc_tax_return',
    'doc_credit_card_statement',
    'doc_bank_statement'
  ],
  [KYBStatusFailed.IDFailed]: [
    'doc_ein_verification',
    'doc_tax_return',
    'doc_tax_w9',
    'doc_tax_ss4'
  ],
  [KYBStatusFailed.GeneralFailed]: [
    'id_drivers_license',
    'id_drivers_permit',
    'id_state',
    'id_military',
    'id_military_dependent',
    'id_passport',
    'id_passport_card'
  ]
};
